import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=41d84872&scoped=true&lang=html&"
import script from "./passwordReset.vue?vue&type=script&lang=js&"
export * from "./passwordReset.vue?vue&type=script&lang=js&"
import style0 from "./passwordReset.vue?vue&type=style&index=0&id=41d84872&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d84872",
  null
  
)

component.options.__file = "passwordReset.vue"
export default component.exports